import React, { useState } from 'react';
import { generateTabPanels, generateTabs } from 'src/components/VemigoTabPanel';
import {
  TabesPage,
  TabsBox,
  activeTabStyle,
  customerStyle
} from 'src/theme/vemigoCustomStyles/VemigoCustomStyles';
import { Box, Divider, Tabs } from '@mui/material';
import AccountCircleRoundedIcon from '@mui/icons-material/AccountCircleRounded';
import BasicInfo from './basicInfo/BasicInfo';
import { useSalesPartnerData } from '../SalesPartnerData';
import SalesPartnerBankAccountsList from './bankAccount/SalesPartnerBankAccountsList';
import SalesPartnerPaymentHistoryList from './paymentHistory';
import Report from './reports/Report';
import Settlements from './reports/Settlements';

const SalesPartnerDetailsTabs = () => {
  const { salesPartner } = useSalesPartnerData();

  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const tabLabels = [
    {
      id: 0,
      label: 'Basic Info',
      page: <BasicInfo />
    },
    { id: 1, label: 'Bank Accounts', page: <SalesPartnerBankAccountsList /> },
    { id: 2, label: 'Payment History', page: <SalesPartnerPaymentHistoryList /> },
    { id: 3, label: 'Report', page: <Report /> },
    { id: 4, label: 'Settlement', page: <Settlements /> }
  ];

  const selectedTabs = salesPartner.name ? tabLabels : [tabLabels[0]];

  const tabs = generateTabs(selectedTabs, value, activeTabStyle);
  const tabPanels = generateTabPanels(selectedTabs, value);

  return (
    <>
      <div style={customerStyle.details}>
        <div style={customerStyle.details2}>
          <AccountCircleRoundedIcon style={customerStyle.iconstyle} />
          <div style={{ fontSize: '24px' }}>
            {salesPartner.name?.length > 0 ? (
              <b>{salesPartner.name}</b>
            ) : (
              'No Details'
            )}
          </div>
        </div>
        <div style={customerStyle.numberIcon}>
          <AccountCircleRoundedIcon style={customerStyle.iconstyle} />
          <div style={{ fontSize: '24px' }}>
            {salesPartner.contactNo?.length > 0 ? (
              <b>{salesPartner.contactNo}</b>
            ) : (
              'No Details'
            )}
          </div>
        </div>
      </div>
      <Divider style={{ marginBottom: '10px' }} />
      <br />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start'
        }}
      >
        <Box style={{ ...TabsBox }}>
          <Tabs
            orientation="vertical"
            style={{ height: 'fit-content', width: '9vw' }}
            value={value}
            onChange={handleChange}
          >
            {tabs}
          </Tabs>
        </Box>
        <Box style={TabesPage}>{tabPanels}</Box>
      </Box>
    </>
  );
}

export default SalesPartnerDetailsTabs;